import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=8b430b2e&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b430b2e')) {
      api.createRecord('8b430b2e', component.options)
    } else {
      api.reload('8b430b2e', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=8b430b2e&", function () {
      api.rerender('8b430b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/Dashboard.vue"
export default component.exports